import { render, staticRenderFns } from "./instrumentPageCard.vue?vue&type=template&id=b2483e60"
import script from "./instrumentPageCard.vue?vue&type=script&lang=js"
export * from "./instrumentPageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports